import { locationFields } from "./LocationFormField";
import { useEffect, useState } from "react";
import { toast } from "../../../components/AppToast";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { height } from "@mui/system";
import { useSelector } from "react-redux";
import { getLocationId } from "../../../services/location/location";
import { countryList } from "../../../data/static";
// import { getLocationID } from "../../../services/location/location";
// import { getGeoAreas } from '../../../services/geography/geography';

// const operationalHoursInitial = daysOfWeek.reduce((acc, day) => {
//     acc[day] = { enabled: false, open: "", close: "" };
//     return acc;
// }, {});


export default function CreateLocation({ initialValues, onSubmit, onCancel, viewOnly, isEdit }) {
  const { userDetail } = useSelector(state => state.login)

  let dayRan={MONDAY:'Monday',TUESDAY:'Tuesday',WEDNESDAY:'Wednesday',THRUSDAY:'Thrusday',FRIDAY:'Friday',SATURDAY:'Saturday'};
  const [operationalHours, setOperationalHours] = useState({});
  const [geoAreas, setGeoAreas] = useState([]);
  const [formData, setFormData] = useState({
    locationId: '',
    locationName: '',
    locationType: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: 'IN',
    pincode: '',
    operationalGeoAreas: [],
    serviceLevel: [],
    operatingHours: [],
    createdBy: '',
    createdDate: '',
    updatedBy: '',
    updatedDate: ''
  });



  const countries = countryList; // Use the imported countryList from static.js

  const locationTypes = ["Retail Store", "Dark Store", "Warehouse", "CFC"];
  const serviceLevels = ["Standard", "Premium", "Express"];

  const handleChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, values) => {
    // console.log(name, values, "multiselect");

    setFormData(prev => ({ ...prev, [name]: values }));
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (!viewOnly && !isEdit) {
        const finalData = {
          ...formData,
        };
        await onSubmit(finalData);
      }
      else {
        setFormData(prev => ({
      ...prev,
      operatingHours: operationalHours
    }));
         await onSubmit(formData,initialValues._id);
      }
    } catch (err) {
      toast.error(err?.data?.message || "Error saving location");
    }
  };

  useEffect(() => {

    // fetchGeoAreas();

    if (!viewOnly && !isEdit) {
      getLocationIDFn();
      setFormData(prev => ({ ...prev, createdBy: userDetail.email }))
    }

  }, []);


  const handleDayChange = (e, day) => {
    const enabled = e.target.checked;

    setOperationalHours((p) => ({
      ...p,
      [day]: enabled
        ? { ...p[day], enabled, open: p[day]?.open || "06:00", close: p[day]?.close || "23:00" }
        : { enabled: false, open: "", close: "" },
    }));
  };


  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      operatingHours: operationalHours
    }));
    
  }, [operationalHours]);

  const handleTimeChange = (day, type, value) => {
    setOperationalHours((p) => ({
      ...p,
      [day]: { ...p[day], [type]: value },
    }));

      
  };

  useEffect(() => {
    // populate form for edit/view
    if ((viewOnly || isEdit) && initialValues) {
      let setHousr={};
      setHousr = initialValues.operatingHours.reduce((acc,num)=>{
        acc[dayRan[num.dayRange]]={enabled:true,open:num.timeRange.open,close:num.timeRange.close}
        return acc;
      },{})

      setOperationalHours(setHousr);
      
      setFormData({
        ...initialValues,
        locationId:initialValues.locationID,
        addressLine1: initialValues.address?.addressLine1 || '',
        addressLine2: initialValues.address?.addressLine2 || '',
        city: initialValues.address?.city || '',
        state: initialValues.address?.state || '',
        country: initialValues.address?.Country || 'IN',
        pincode: initialValues.address?.Pincode || '',
        
      });

      if (isEdit) {
        setFormData(prev=>({
          ...prev,
          updatedBy: userDetail.email,
          updatedDate: new Date()
        }));
      }
      else {
        setFormData(prev=>({
          ...prev,
          updatedBy: initialValues.updatedBy,
          updatedDate: initialValues.updatedDate
        }));
      }
    }
  }, [viewOnly, isEdit, initialValues]);

  const getLocationIDFn = async () => {
    let res = await getLocationId();
    // console.log(res);

    if (res.success) {
      setFormData(prev => ({ ...prev, locationId: res.data }));
    }
  };



  // const fetchGeoAreas = async () => {
  //   try {
  //     const data = [];
  //     // const data = await getGeoAreas(); // API to get geography master
  //     setGeoAreas(data || []);
  //   } catch (err) {
  //     console.error("Error fetching geo areas:", err);
  //   }
  // };

  return (
    <form>
      <div className="d-flex flex-wrap gap-3">
        {locationFields.map((field) => (
          <div
            key={field.name}
            className="mb-1"
            style={{ flex: `0 0 ${field.width || "15%"}` }}
          >
            <label className="form-label">
              {field.label}
              {field.required && <span className="text-danger"> *</span>}
            </label>

            {field.type === 'select' ? (
              <select
                className="form-select"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
                disabled={viewOnly || field.readonly}
              >
                <option value="">Select</option>
                {field.name === 'country' && countries.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
                {field.name === 'locationType' && locationTypes.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
                {field.name === 'serviceLevel' && field.options?.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            ) : field.type === 'multiselect' ? (

              <Select
                multiple
                disabled={viewOnly || field.readonly}
                sx={{ height: '38px' }}
                className="form-select"
                value={formData[field.name] || []}
                onChange={(e) => handleMultiSelectChange(field.name, e.target.value)}
                renderValue={(selected) => selected.join(', ')}

              >
                {field.name === 'operationalGeoAreas' &&
                  field.options.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox
                        checked={(formData[field.name] || []).includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))
                }
              </Select>

            ) : (
              <input
                type={field.type || "text"}
                className="form-control"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
                readOnly={viewOnly || field.readonly}
              />
            )}
          </div>
        ))}
      </div>

      {/* Operating Hours */}
      <div className="border-bottom pb-3 mb-3">
        <h6 className="fw-bold mb-3">Operational Hours</h6>
        <div className="row gx-3 gy-3">
          {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
            <div key={day} className="col-md-3">
              <div className="d-flex flex-column border rounded p-2 bg-light">
                <div className="form-check mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={operationalHours[day]?.enabled || false}
                    onChange={(e) => handleDayChange(e, day)}
                    disabled={viewOnly }
                  />
                  <label className="form-check-label small">{day}</label>
                </div>
                <div className="d-flex justify-content-between">
                  <input
                    type="time"
                    className="form-control form-control-sm me-1"
                    value={operationalHours[day]?.open || "06:00"}
                    disabled={viewOnly }
                    // disabled={!operationalHours[day]?.enabled || readOnly}
                    onChange={(e) => handleTimeChange(day, "open", e.target.value)}
                  />
                  <input
                    type="time"
                    className="form-control form-control-sm ms-1"
                    value={operationalHours[day]?.close || "23:00"}
                    disabled={viewOnly }
                    // disabled={!operationalHours[day]?.enabled || readOnly}
                    onChange={(e) => handleTimeChange(day, "close", e.target.value)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="d-flex justify-content-center gap-2 mt-3">
        <button className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>
        {!viewOnly && !isEdit && (
          <button className="btn btn-primary" onClick={submit}>
            Save
          </button>
        )}
        {isEdit && !viewOnly && (
          <button className="btn btn-primary" onClick={submit}>
            Update
          </button>
        )}
      </div>
    </form>
  );
}
